export const menuItems = [
    {
        id: 1,
        label: 'PRODUCTOS',
        icon: 'ri-dashboard-line',
        link: '/'
    },
    {
        id: 2,
        label: 'VINOS Y LICORES',
        icon: 'ri-dashboard-line',
        link: '/bebidas'
    },
    {
        id: 3,
        label: 'CATEGORIAS',
        icon: 'ri-dashboard-line',
        link: '/categorias'
    },
    {
        id: 4,
        label: 'SUBCATEGORIAS',
        icon: 'ri-dashboard-line',
        link: '/subcategorias'
    },
    {
        id: 5,
        label: 'ESPECIALES',
        icon: 'ri-dashboard-line',
        link: '/especiales'
    },
    {
        id: 6,
        label: 'ORDEN PRODUCTOS',
        icon: 'ri-dashboard-line',
        link: '/orden'
    },
    {
        id: 7,
        label: 'ORDEN CATEGORIAS',
        icon: 'ri-dashboard-line',
        link: '/orden-categorias'
    },
    {
        id: 8,
        label: 'ORDEN SUBCATEGORIAS',
        icon: 'ri-dashboard-line',
        link: '/orden-subcategorias'
    },
]